module.exports = __webpack_public_path__ + "img/flower-07.be7636ae.png";